import React, { useState } from "react";

import GreyTable from '../../../../components/Tables/GreyTable'
import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { Loader } from '../../../../components/Loader/Loader';
import { useTheme } from '../../../../Themecontext/Themecontext';

export const Balance365 = ({ Muldata }) => {

  const { AccountToPGroupListData } = useSelector((state) => state.PartyProfileSlice);
  const { Balance365Data } = useSelector((state) => state.PartyProfileSlice);

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;


  const monthOrder = [
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
    "January",
    "February",
    "March",
  ];

  const Date = [
    "Billing",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
  ];

  const columns = [
    // { Header: "Chart", accessor: "chartButton", width: "60px" },
    { key: "srNumber", label: "Sr. No.", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "Month", label: "Month", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "Billing", label: "Balance Meter", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    ...Array.from({ length: 31 }, (_, i) => ({
      key: `${i + 1}`,
      label: `${i + 1}`,
      width: 125,
      format: true,
      align: "right",
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5
    })),
  ];



  const sortByMonth = (dataArray) => {
    return [...(dataArray || [])].sort((a, b) => {
      const indexA = monthOrder.indexOf(a.Month);
      const indexB = monthOrder.indexOf(b.Month);
      return (indexA !== -1 ? indexA : 99) - (indexB !== -1 ? indexB : 99);
    });
  };

  const formattedRows = sortByMonth(Balance365Data?.Bal365)?.map(
    (row, index, arr) => {
      const totalLength = arr.length.toString().length;
      const formattedRow = {
        // srNumber: (index + 1).toString().padStart(totalLength, "0"),
        id: index,
        ...row,
      };

      if (formattedRow.Month) {
        formattedRow.Month = formattedRow.Month.split("'")[0];
      }

      Date.forEach((accessor) => {
        formattedRow[accessor] = row[accessor];
      });

      return formattedRow;
    }
  );


  if (Balance365Data === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }


  return (
    <>
      <div>
        <Row>
          <Col>
            <>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour8,
                    padding: "14px",
                  }}
                >
                  <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px", fontWeight: "700" }}>
                    MERGING
                  </h2>
                </div>

                {formattedRows?.length > 0 ? (
                  <GreyTable columns={columns} data={formattedRows} iscolourDark={iscolourDark}
                    iscolour={iscolour} />
                ) : (
                  <p
                    style={{
                      color: "#ff0000",
                      fontWeight: "bold",
                      padding: "10px",
                    }}
                  >
                    Data Not Found
                  </p>
                )}
              </div>
            </>
            {/* Group-wise Tables */}
            {Muldata?.map((el) => {
              const sortedBal365 = sortByMonth(el?.Bal365);

              const formattedRows1 = sortedBal365?.map((row, index, arr) => {
                const formattedRow = {
                  // srNumber: (index + 1)
                  //   .toString()
                  //   .padStart(arr.length.toString().length, "0"),
                  id: index,
                  ...row,
                };

                if (formattedRow.Month) {
                  formattedRow.Month = formattedRow.Month.split("'")[0];
                }

                Date.forEach((accessor) => {
                  formattedRow[accessor] = row[accessor];
                });

                return formattedRow;
              });

              return (
                <React.Fragment key={el.group}>

                  <div
                    style={{
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                      marginTop: "20px"
                    }}
                  >
                    <div
                      style={{
                        backgroundColor:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour8,
                        padding: "14px",
                      }}
                    >
                      <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px", fontWeight:"700" }}>
                      {AccountToPGroupListData?.Data?.find(
                        (nel) => Number(el.group) === Number(nel.ProductionGroupMstID)
                      )?.ProductionGroupMstName || `Group ${el.group}`}
                    </h2>
                  </div>

                  {formattedRows1?.length > 0 ? (
                    <GreyTable columns={columns} data={formattedRows1} iscolourDark={iscolourDark}
                      iscolour={iscolour} />
                  ) : (
                    <p
                      style={{
                        color: "#ff0000",
                        fontWeight: "bold",
                        padding: "10px",
                      }}
                    >
                      Data Not Found
                    </p>
                  )}
                </div>
                </React.Fragment>
          );
            })}
        </Col >
      </Row>
    </div >
    </>
  )
}


